import React from 'react'
import { Banner, Text } from 'pcln-design-system'
import { connect } from 'react-redux'

import { BannerContainer } from './OverfilteredBanner.styles'
import { isServerSide } from '../../util/isServerSide'
import { OverfilteredBannerContent } from './OverfilteredBannerContent'

export const OverfilteredBanner = ({ overFilteredTimeStamp, setAttributeText }) => {
  if (!overFilteredTimeStamp) {
    return null
  }

  // If over filtered, scroll to top and render the banner
  if (!isServerSide) {
    window.scrollTo(0, 0)
  }

  return (
    <BannerContainer>
      <Banner
        bg={'notify.light'}
        color={'text.dark'}
        borderRadius={'12px'}
        p={3}
        mt={2}
        mb={2}
        showIcon={false}
      >
        {setAttributeText ? (
          <Text color={'text.dark'}>This filter is unavailable for this itinerary at this time</Text>
        ) : (
          <OverfilteredBannerContent />
        )}
      </Banner>
    </BannerContainer>
  )
}

export const mapStateToProps = (state) => ({
  overFilteredTimeStamp: state.flags.overFilteredTimeStamp,
  setAttributeText: state.flags.setAttributeText,
})

const OverfilteredBannerContainer = connect(mapStateToProps)(OverfilteredBanner)

export { OverfilteredBannerContainer }
